import { useEffect, useState } from 'react';
import { add } from 'date-fns';

const useTimeSlots = (startDateTime, endDateTime, duration) => {
    const [timeSlots, setTimeSlots] = useState([]);

    useEffect(() => {
        if (!startDateTime || !endDateTime || !duration) {
            return;
        }

        const slots = [];
        let moving = startDateTime;

        while (moving < endDateTime) {
            const slotStart = moving;
            const slotEnd = add(moving, { minutes: duration });

            slots.push({
                start: slotStart,
                end: slotEnd,
            });

            moving = slotEnd;
        }

        setTimeSlots(slots);
    }, [startDateTime, endDateTime, duration]);

    return timeSlots;
};

export default useTimeSlots;
